import React from 'react'
import { AssetMasterRouteImport } from './Imports'
const { RoutesMap, AddCategory, UpdateCategory, CategoryList, AddBlock, UpdateBlock, BlockList, AddLocation, UpdateLocation, LocationList, AddSubLocation, UpdateSubLocation, SubLocationList, AddDepartment, UpdateDepartment, DepartmentList, AddItemCategory, UpdateItemCategory, ItemCategoryList, AddItem, UpdateItem, ItemList, AddVendor, UpdateVendor, VendorList, AddBrand, BrandList, UpdateBrand, SkillMatrixList, AddSkillMatrix, UpdateSkillMatrix, AddInventoryUnit, UpdateInventoryUnit, InventoryUnitList, TaskStatusList, AddTaskStatus, UpdateTaskStatus, SlaAndPriorityList, AddSlaAndPriority, UpdateSlaAndPriority, AddStaff, UpdateStaff, StaffList, SubCategoryList, AddSubCategory, UpdateSubCategory, AddSpareParts, UpdateSpareParts, SparePartsList, AddTools, UpdateTools, ToolsList, AddShift, UpdateShift, ShiftList, ReasonList, AddReason, UpdateReason, CityList, CountryList, StateList, AddServiceDepartment, UpdateServiceDepartment, ServiceDepartmentList, AddMasterChecklist, UpdateMasterChecklist, MasterChecklistList } = AssetMasterRouteImport

const AssetMasterRoute = () => {
    return [
        {
            path: RoutesMap.ADD_CATEGORY.path,
            element: <AddCategory />
        },
        {
            path: RoutesMap.UPDATE_CATEGORY.path,
            element: <UpdateCategory />
        },
        {
            path: RoutesMap.CATEGORY_LIST.path,
            element: <CategoryList />
        },


        {
            path: RoutesMap.ADD_BLOCK.path,
            element: <AddBlock />
        },
        {
            path: RoutesMap.UPDATE_BLOCK.path,
            element: <UpdateBlock />
        },
        {
            path: RoutesMap.BLOCK_LIST.path,
            element: <BlockList />
        },


        {
            path: RoutesMap.ADD_LOCATION.path,
            element: <AddLocation />
        },
        {
            path: RoutesMap.UPDATE_LOCATION.path,
            element: <UpdateLocation />
        },
        {
            path: RoutesMap.LOCATION_LIST.path,
            element: <LocationList />
        },


        {
            path: RoutesMap.ADD_SUB_LOCATION.path,
            element: <AddSubLocation />
        },
        {
            path: RoutesMap.UPDATE_SUB_LOCATION.path,
            element: <UpdateSubLocation />
        },
        {
            path: RoutesMap.SUB_LOCATION_LIST.path,
            element: <SubLocationList />
        },


        {
            path: RoutesMap.ADD_DEPARTMENT.path,
            element: <AddDepartment />
        },
        {
            path: RoutesMap.UPDATE_DEPARTMENT.path,
            element: <UpdateDepartment />
        },
        {
            path: RoutesMap.DEPARTMENT_LIST.path,
            element: <DepartmentList />
        },

        {
            path: RoutesMap.ADD_SERVICE_DEPARTMENT.path,
            element: <AddServiceDepartment />
        },
        {
            path: RoutesMap.UPDATE_SERVICE_DEPARTMENT.path,
            element: <UpdateServiceDepartment />
        },
        {
            path: RoutesMap.SERVICE_DEPARTMENT_LIST.path,
            element: <ServiceDepartmentList />
        },


        {
            path: RoutesMap.ADD_ITEM_CATEGORY.path,
            element: <AddItemCategory />
        },
        {
            path: RoutesMap.UPDATE_ITEM_CATEGORY.path,
            element: <UpdateItemCategory />
        },
        {
            path: RoutesMap.ITEM_CATEGORY_LIST.path,
            element: <ItemCategoryList />
        },


        {
            path: RoutesMap.ADD_ITEM.path,
            element: <AddItem />
        },
        {
            path: RoutesMap.UPDATE_ITEM.path,
            element: <UpdateItem />
        },
        {
            path: RoutesMap.ITEM_LIST.path,
            element: <ItemList />
        },


        {
            path: RoutesMap.ADD_VENDOR.path,
            element: <AddVendor />
        },
        {
            path: RoutesMap.UPDATE_VENDOR.path,
            element: <UpdateVendor />
        },
        {
            path: RoutesMap.VENDOR_LIST.path,
            element: <VendorList />
        },


        //    shudhanshu-----------------------------

        {
            path: RoutesMap.BRAND_LIST.path,
            element: <BrandList />
        },
        {
            path: RoutesMap.ADD_BRAND.path,
            element: <AddBrand />
        },
        {
            path: RoutesMap.UPDATE_BRAND.path,
            element: <UpdateBrand />
        },


        {
            path: RoutesMap.SKILL_MATRIX_LIST.path,
            element: <SkillMatrixList />
        },
        {
            path: RoutesMap.ADD_SKILL_MATRIX.path,
            element: <AddSkillMatrix />
        },
        {
            path: RoutesMap.UPDATE_SKILL_MATRIX.path,
            element: <UpdateSkillMatrix />
        },


        {
            path: RoutesMap.INVENTORY_UNIT_LIST.path,
            element: <InventoryUnitList />
        },
        {
            path: RoutesMap.ADD_INVENTORY_UNIT.path,
            element: <AddInventoryUnit />
        },
        {
            path: RoutesMap.UPDATE_INVENTORY_UNIT.path,
            element: <UpdateInventoryUnit />
        },

        {
            path: RoutesMap.TASK_STATUS_LIST.path,
            element: <TaskStatusList />
        },
        {
            path: RoutesMap.ADD_TASK_STATUS.path,
            element: <AddTaskStatus />
        },
        {
            path: RoutesMap.UPDATE_TASK_STATUS.path,
            element: <UpdateTaskStatus />
        },

        {
            path: RoutesMap.SLA_AND_PRIORITY_LIST.path,
            element: <SlaAndPriorityList />
        },
        {
            path: RoutesMap.ADD_SLA_AND_PRIORITY.path,
            element: <AddSlaAndPriority />
        },
        {
            path: RoutesMap.UPDATE_SLA_AND_PRIORITY.path,
            element: <UpdateSlaAndPriority />
        },


        {
            path: RoutesMap.STAFF_LIST.path,
            element: <StaffList />
        },
        {
            path: RoutesMap.ADD_STAFF.path,
            element: <AddStaff />
        },
        {
            path: RoutesMap.UPDATE_STAFF.path,
            element: <UpdateStaff />
        },


        {
            path: RoutesMap.SUB_CATEGORY_LIST.path,
            element: <SubCategoryList />
        },
        {
            path: RoutesMap.ADD_SUB_CATEGORY.path,
            element: <AddSubCategory />
        },
        {
            path: RoutesMap.UPDATE_SUB_CATEGORY.path,
            element: <UpdateSubCategory />
        },

        {
            path: RoutesMap.SPARE_PARTS_LIST.path,
            element: <SparePartsList />
        },
        {
            path: RoutesMap.ADD_SPARE_PARTS.path,
            element: <AddSpareParts />
        },
        {
            path: RoutesMap.UPDATE_SPARE_PARTS.path,
            element: <UpdateSpareParts />
        },

        {
            path: RoutesMap.TOOLS_LIST.path,
            element: <ToolsList />
        },
        {
            path: RoutesMap.ADD_TOOLS.path,
            element: <AddTools />
        },
        {
            path: RoutesMap.UPDATE_TOOLS.path,
            element: <UpdateTools />
        },

        {
            path: RoutesMap.SHIFT_LIST.path,
            element: <ShiftList />
        },
        {
            path: RoutesMap.ADD_SHIFT.path,
            element: <AddShift />
        },
        {
            path: RoutesMap.UPDATE_SHIFT.path,
            element: <UpdateShift />
        },

        {
            path: RoutesMap.REASON_LIST.path,
            element: <ReasonList />
        },
        {
            path: RoutesMap.ADD_REASON.path,
            element: <AddReason />
        },
        {
            path: RoutesMap.UPDATE_REASON.path,
            element: <UpdateReason />
        },


        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.ADD_MASTER_CHECKLIST.path,
            element: <AddMasterChecklist />
        },
        {
            path: RoutesMap.UPDATE_MASTER_CHECKLIST.path,
            element: <UpdateMasterChecklist />
        },
        {
            path: RoutesMap.MASTER_CHECKLIST_LIST.path,
            element: <MasterChecklistList />
        },

    ]
}

export default AssetMasterRoute;